import { useEffect, useState } from 'react'
import { highlightBrowserLog } from '../helpers/log'
import { ScarabQueue, variableName } from './Emarsys'

export const useInitializeEmarsys = (
  EMARSYS_MERCHANT_ID: string,
  EMARSYS_MERCHANT_APPLICATION_CODE: string,
  EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID: string,
  EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY: string,
) => {
  const [emarsysFired, setEmarsysFired] = useState(false)

  useEffect(() => {
    if (!EMARSYS_MERCHANT_ID) {
      highlightBrowserLog('EMARSYS ID is required to initialize.')
      return
    }

    /* Verifica se o EMARSYS já foi carregado */
    if (document.getElementById('emarsys-script')) {
      highlightBrowserLog('EMARSYS já inicializado.')
      return
    }

    /* Cria a dataLayer global se ainda não existir */
    if (!window[variableName]) {
      window[variableName] = []
    }

    if (!window[ScarabQueue]) {
      window[ScarabQueue] = []
    }

    window.EMARSYS_MERCHANT_ID = EMARSYS_MERCHANT_ID
    window.EMARSYS_WEB_PUSH = {
      applicationCode: EMARSYS_MERCHANT_APPLICATION_CODE,
      safariWebsitePushID: EMARSYS_MERCHANT_SAFARI_WEBSITE_PUSH_ID,
      applicationServerPublicKey: EMARSYS_MERCHANT_APPLICATION_SERVER_PUBLIC_KEY,
    }

    /* Adiciona o script do EMARSYS ao documento */
    const emarsysScript = document.createElement('script')
    emarsysScript.id = 'emarsys-script'
    emarsysScript.src = `https://recommender.scarabresearch.com/js/${EMARSYS_MERCHANT_ID}/scarab-v2.js`
    emarsysScript.async = true

    const emarsysSdk = document.createElement('script')
    emarsysSdk.id = 'emarsys-sdk-script'
    emarsysSdk.src = `https://assets.emarsys.net/web-emarsys-sdk/4.5.0/web-emarsys-sdk.js`
    emarsysSdk.async = true

    document.head.appendChild(emarsysScript)
    document.head.appendChild(emarsysSdk)

    document.querySelector('body')?.classList.add('web-emarsys-sdk-loaded')

    setEmarsysFired(true)
    highlightBrowserLog('emarsys inicializado com sucesso.')
  }, [EMARSYS_MERCHANT_ID])

  return emarsysFired
}
